/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _vdkwebNavigation = require("@accedo/vdkweb-navigation");
var _FocusButton = _interopRequireDefault(require("./FocusButton"));
var _daySelector = _interopRequireDefault(require("./daySelector.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var defaultDayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var getDayNameForDate = function getDayNameForDate(_ref) {
  var dayNames = _ref.dayNames,
    date = _ref.date;
  if (!dayNames || !date) {
    return '';
  }
  var weekDay = typeof date.day === 'function' ? date.day() : new Date(date).getDay();
  return dayNames.length > weekDay && dayNames[weekDay] || '';
};
var DaySelector = function DaySelector(_ref2) {
  var selectedIndex = _ref2.selectedIndex,
    onDaySelected = _ref2.onDaySelected,
    _ref2$days = _ref2.days,
    days = _ref2$days === void 0 ? [] : _ref2$days,
    _ref2$dayNames = _ref2.dayNames,
    dayNames = _ref2$dayNames === void 0 ? defaultDayNames : _ref2$dayNames,
    _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? _daySelector["default"] : _ref2$theme,
    nav = _ref2.nav,
    rtl = _ref2.rtl;
  var daysToMap = _toConsumableArray(days);
  if (rtl) {
    daysToMap.reverse();
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.daySelectorContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.daysContainer
  }, daysToMap.map(function (_ref3, index) {
    var label = _ref3.label,
      date = _ref3.date;
    var dayIndex = index;
    if (rtl) {
      dayIndex = daysToMap.length - 1 - index;
    }
    var dayName = label || getDayNameForDate({
      dayNames: dayNames,
      date: date
    });
    var nextDay = dayIndex === daysToMap.length - 1 ? null : "day".concat(dayIndex + 1);
    var previousDay = dayIndex === 0 ? null : "day".concat(dayIndex - 1);
    var nextleft = rtl ? nextDay : previousDay;
    var nextright = rtl ? previousDay : nextDay;
    var id = "day".concat(dayIndex);
    return /*#__PURE__*/_react["default"].createElement(_FocusButton["default"], {
      key: dayIndex,
      isSelected: selectedIndex === dayIndex,
      nav: {
        id: id,
        parent: nav.id,
        nextleft: nextleft,
        nextright: nextright
      },
      onClick: function onClick() {
        return onDaySelected(dayIndex);
      },
      theme: theme
    }, dayName);
  })));
};
DaySelector.propTypes = {
  /**
   * A list of day names matching the
   * week day names in the following order:
   *
   * [Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, Saturday]
   *
   * By default, the above are used if none are passed in.
   */
  dayNames: _propTypes["default"].array,
  /**
   * Date and label data for days to
   * show in the day selector.
   *
   * Expects objects with a ```date````
   * property holding the date timestamp
   * for the day (or a Moment.js date object),
   * and an optional ```label````
   * property for the label to show for this day.
   * If no label is given, the corresponding
   * weekday name will be used.
   */
  days: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    date: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].object]),
    label: _propTypes["default"].string
  })),
  /** The @accedo/vdkweb-navigation nav object */
  nav: _propTypes["default"].object,
  /**
   * Handler which will be triggered when a
   * day is selected. Will be provided with
   * the index of the selected day.
   */
  onDaySelected: _propTypes["default"].func,
  rtl: _propTypes["default"].bool,
  /**
   * The index of the initially selected day.
   */
  selectedIndex: _propTypes["default"].number,
  /**
   * Classname API for theming
   */
  theme: _propTypes["default"].shape({
    childContainer: _propTypes["default"].string,
    dayButton: _propTypes["default"].string,
    daysContainer: _propTypes["default"].string,
    daySelectorContainer: _propTypes["default"].string
  })
};
var _default = (0, _vdkwebNavigation.withFocus)(DaySelector);
exports["default"] = _default;